module.exports = __webpack_public_path__ + "img/hotel_list_banner.4974ca69.gif";